<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <ion-grid>
        <ion-row>
          <ion-col v-if="shouldEncourageToGetMobileApp" size="12" size-sm>
            <ion-grid>
              <ion-row>
                <ion-col size="12" size-lg="8" offset-lg="2">
                  <get-the-app />
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
          <ion-col size="12" size-sm>
            <p v-if="canCustomerSignIn">
              Welcome back! It's good to see you again. Let's get you signed in
              so you can get the best food and drink delivered right to your
              seat.
            </p>
            <p class="ion-padding-bottom">Sign in with...</p>
            <p>
              <ion-button
                v-if="canApple"
                expand="block"
                @click="handleSignInWithApple()"
                ref="apple-sign-in"
                class="no-casing"
                style="--background: black"
              >
                <img src="./apple.svg" slot="start" />
                Sign in with Apple
              </ion-button>
            </p>
            <p>
              <ion-button
                expand="block"
                @click="handleSignInWithGoogle()"
                class="no-casing"
                style="--background: #f4f5f8; color: #000000"
              >
                Sign in with Google
              </ion-button>
            </p>
            <p>
              <ion-button
                expand="block"
                @click="handleSignInWithFacebook()"
                class="no-casing"
                style="--background: #3b5998"
              >
                Sign in with Facebook
              </ion-button>
            </p>
            <p>
              <ion-button
                expand="block"
                @click="handleSignInWithEmail()"
                class="no-casing"
                >Email and Password</ion-button
              >
            </p>
            <ion-card v-if="!canCustomerSignIn" color="danger">
              <ion-card-content>
                <div class="ion-text-center">
                  Only Stay Seated Staff can login here. If you'd like to place
                  an order, download the free app.
                </div>
              </ion-card-content>
            </ion-card>
            <section v-if="canSignUp" class="ion-padding ion-margin">
              <hr class="divider" />
            </section>
            <p v-if="canSignUp" class="ion-text-center">
              <ion-button
                size="small"
                fill="clear"
                color="dark"
                @click="handleNoAccount()"
              >
                I don't have an account.
              </ion-button>
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import FeatureService from "@/services/Feature";
import PlatformService from "@/services/Platform";
import GetTheApp from "@/components/Shared/GetTheApp/GetTheApp";
import { mapActions, mapGetters } from "vuex";
import ErrorAlert from "@/ErrorAlert";

export default {
  title: "Sign In",

  components: {
    "get-the-app": GetTheApp
  },

  methods: {
    ...mapActions("auth", [
      "signInWithGoogle",
      "signInWithFacebook",
      "signInWithApple"
    ]),

    handleNoAccount() {
      this.$router.push({ name: "Sign Up" });
    },

    handleSignInWithEmail() {
      this.$router.push({ name: "Sign In With Email" });
    },

    async handleSignInWithGoogle() {
      let loginResult = await this.signInWithGoogle();
      this.handleAuthNextStep(loginResult);
    },

    async handleSignInWithFacebook() {
      let loginResult = await this.signInWithFacebook();
      this.handleAuthNextStep(loginResult);
    },

    async handleSignInWithApple() {
      let loginResult = await this.signInWithApple();
      this.handleAuthNextStep(loginResult);
    },

    handleAuthNextStep(loginResult) {
      if (loginResult === false) {
        ErrorAlert(this.authError.message);
      } else {
        this.$router.push("/").catch(e => e);
      }
    }
  },

  computed: {
    ...mapGetters("auth", ["authError"]),

    canApple() {
      return !PlatformService.isAndroid();
    },
    canSignUp: () => {
      return FeatureService.canSignUp();
    },
    canCustomerSignIn: () => {
      return FeatureService.canCustomerSignIn();
    },
    shouldEncourageToGetMobileApp: () => {
      return FeatureService.shouldEncourageToGetMobileApp();
    }
  }
};
</script>

<style lang="scss">
.no-casing {
  text-transform: none;
}
</style>
